module.exports = __webpack_public_path__ + "img/制御工学3_10_5.30d4aa67.png";